import { EItemFormatType } from "../../pages/SimuladorInteligente/interfaces";
import cnpj from "../../pages/SimuladorInteligente/utils/masks/cnpj";
import cpf from "../../pages/SimuladorInteligente/utils/masks/cpf";
import currency from "../../pages/SimuladorInteligente/utils/masks/currency";
import phone from "../../pages/SimuladorInteligente/utils/masks/phone";

interface IFormatProps {
  format: EItemFormatType | undefined,
  value: any,
}

export function formatValue({
  format,
  value,
}: IFormatProps) {
  if (format === EItemFormatType.CNPJ) {
    return cnpj.mask(value);
  }

  if (format === EItemFormatType.CELLPHONE) {
    return phone.mask(value);
  }

  if (format === EItemFormatType.CURRENCY) {
    const number = Number(value);
    return `R$ ${currency.mask(number.toFixed(2))}`;
  }

  if (format === EItemFormatType.CPF) {
    return cpf.mask(value);
  }

  return value;
}

export function formatValueToXLSX({
  format,
  value
}: IFormatProps) {
  if (format === EItemFormatType.CURRENCY) {
    return value;
  }

  return formatValue({ format, value });
}

export function formatStringList(list: string[]): string {
  if (list.length === 1) {
    return `${list[0]}`;
  }

  const todosMenosUltimo = list.slice(0, -1).join(", ");
  const ultimo = list[list.length - 1];
  return `${todosMenosUltimo} e ${ultimo}`;
}
